"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QP_ANCHOR_EVENT_LABELS = exports.QP_ANCHOR_EVENTS = void 0;
exports.normalizeQpAnchorEvent = normalizeQpAnchorEvent;
// Stable, machine-readable anchor event codes for the quotation period on
// Formula/Index-priced tickets. Used on both QP Start and QP End; the actual
// date is `anchor + offset_days`, with a manual date override stored alongside.
// Renaming a code is a breaking change.
exports.QP_ANCHOR_EVENTS = [
    'DEAL_DATE',
    'CONTRACT_SIGNED',
    'MATERIAL_READY',
    'LOADING_DATE',
    'BL_DATE',
    'ETA_DATE',
    'ATA_DATE',
    'FULLY_PAID',
    'DP_PAID',
    'TITLE_TRANSFER',
];
exports.QP_ANCHOR_EVENT_LABELS = {
    DEAL_DATE: 'Deal Date',
    CONTRACT_SIGNED: 'Contract Signed',
    MATERIAL_READY: 'Material Ready',
    LOADING_DATE: 'Loading Date',
    BL_DATE: 'BL Date',
    ETA_DATE: 'ETA Date',
    ATA_DATE: 'ATA Date',
    FULLY_PAID: 'Fully Paid',
    DP_PAID: 'DP Paid',
    TITLE_TRANSFER: 'Title Transfer',
};
// Legacy tickets predate the enum and carry free-text anchors ("ETA at PoD",
// "Contract signature", …). Keys are lowercased/trimmed for the lookup; the
// variant set matches the qp_alignment view's normalization, plus the UI
// labels. "ATA at PoD" stays mapped to ETA_DATE (whose resolution already
// prefers the actual arrival once it exists) — remapping legacy tickets to
// the stricter ATA_DATE anchor would change their declared windows; ATA_DATE
// is for tickets that pick it explicitly.
const LEGACY_QP_ANCHOR_VARIANTS = {
    'deal date': 'DEAL_DATE',
    'contract signature': 'CONTRACT_SIGNED',
    'contract signed': 'CONTRACT_SIGNED',
    'contract signed date': 'CONTRACT_SIGNED',
    'material ready': 'MATERIAL_READY',
    loading: 'LOADING_DATE',
    'loading date': 'LOADING_DATE',
    'bl issuance': 'BL_DATE',
    'bl date': 'BL_DATE',
    eta: 'ETA_DATE',
    'eta date': 'ETA_DATE',
    'eta at pod': 'ETA_DATE',
    'ata at pod': 'ETA_DATE',
    'fully paid': 'FULLY_PAID',
    downpayment: 'DP_PAID',
    'receipt of downpayment': 'DP_PAID',
    'dp paid': 'DP_PAID',
    'title transfer': 'TITLE_TRANSFER',
};
function normalizeQpAnchorEvent(raw) {
    if (!raw)
        return null;
    const trimmed = raw.trim();
    if (exports.QP_ANCHOR_EVENTS.includes(trimmed)) {
        return trimmed;
    }
    return LEGACY_QP_ANCHOR_VARIANTS[trimmed.toLowerCase()] ?? null;
}
//# sourceMappingURL=qp-anchors.js.map